var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 3.6H3.6C2.16406 3.6 1 4.76406 1 6.2V24.4C1 25.8359 2.16406 27 3.6 27H21.8C23.2359 27 24.4 25.8359 24.4 24.4V6.2C24.4 4.76406 23.2359 3.6 21.8 3.6Z",
    stroke: "#39A2DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 1V6.2",
    stroke: "#39A2DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1V6.2",
    stroke: "#39A2DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.4H24.4",
    stroke: "#39A2DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.9933C16 19.3856 15.9632 19.7747 15.8895 20.1608C15.8198 20.5468 15.6957 20.9111 15.5174 21.2535C15.3391 21.5928 15.0891 21.8948 14.7674 22.1594C14.4457 22.4209 14.0368 22.6264 13.5407 22.7759C13.0446 22.9253 12.4438 23 11.7384 23C11.5717 23 11.376 22.9938 11.1512 22.9813C10.9264 22.972 10.7403 22.9564 10.593 22.9346V21.7765C10.7481 21.8076 10.9128 21.8326 11.0872 21.8512C11.2616 21.8668 11.438 21.8746 11.6163 21.8746C12.3256 21.8746 12.8721 21.7843 13.2558 21.6037C13.6434 21.4232 13.9147 21.1726 14.0698 20.8519C14.2287 20.5312 14.3198 20.1608 14.343 19.7405H14.2733C14.1609 19.8899 14.0271 20.0254 13.8721 20.1468C13.7209 20.2651 13.5271 20.36 13.2907 20.4316C13.0543 20.5001 12.7539 20.5344 12.3895 20.5344C11.905 20.5344 11.4826 20.4503 11.1221 20.2822C10.7655 20.111 10.4884 19.865 10.2907 19.5444C10.0969 19.2206 10 18.8299 10 18.3722C10 17.8773 10.1163 17.4539 10.3488 17.1021C10.5853 16.7472 10.9205 16.4748 11.3547 16.2849C11.7888 16.095 12.3004 16 12.8895 16C13.3236 16 13.7287 16.0607 14.1047 16.1821C14.4806 16.3004 14.8101 16.4825 15.093 16.7285C15.3798 16.9744 15.6027 17.2857 15.7616 17.6624C15.9205 18.0391 16 18.4828 16 18.9933ZM12.9244 17.1581C12.5756 17.1581 12.2907 17.2546 12.0698 17.4476C11.8488 17.6406 11.7384 17.9426 11.7384 18.3536C11.7384 18.6836 11.8333 18.9451 12.0233 19.1381C12.2132 19.3311 12.5019 19.4276 12.8895 19.4276C13.157 19.4276 13.3895 19.3809 13.5872 19.2875C13.7849 19.191 13.938 19.0712 14.0465 18.928C14.1589 18.7816 14.2151 18.6322 14.2151 18.4797C14.2151 18.3209 14.188 18.1637 14.1337 18.008C14.0795 17.8523 13.9981 17.7107 13.8895 17.5831C13.781 17.4554 13.6453 17.3527 13.4826 17.2748C13.3236 17.197 13.1376 17.1581 12.9244 17.1581Z",
    fill: "#39A2DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.0309b710c8660431a4f2be1498e0cc24.svg";
export { ForwardRef as ReactComponent };